export default {
    "account": {
        "InvoiceDialogue": {
            "title": "Vos factures"
        },
        "bookmark": {
            "list": {
                "actions": "Actions",
                "dt": "date",
                "tags": "Mots clés",
                "url": "Page web"
            },
            "menu_name": "Mes favoris",
            "title": "Classer mes sites favoris"
        },
        "entity": {
            "menu_name": "Entreprise",
            "title": "Mon entreprise"
        },
        "form": {
            "avatar": "Avatar",
            "bio": "Bio",
            "bio_link": "Une Url vous décrivant (doit débuter par https://) ",
            "bio_text": "Une phrase vous décrivant",
            "birth_date": "Date de naissance",
            "email": "Email",
            "email_invoice": "Adresse email pour la réception des factures",
            "first_name": "Prénom",
            "gender": {
                "label": "Genre",
                "men": "homme",
                "non_binary": "ne se prononce pas",
                "women": "femme"
            },
            "landline": "Téléphone fixe",
            "last_name": "Nom",
            "mobile_phone": "Téléphone mobile",
            "second_email": "Seconde adresse email",
            "update": "Informations du compte mises à jour.",
            "user_name": "Pseudo"
        },
        "invoices": {
            "menu_name": "Factures",
            "title": "Mes factures"
        },
        "logout": "Déconnexion",
        "logout_all": "Déconnecter tous mes appareils",
        "menu_name": "Me déconnecter",
        "modify": "Déverrouiller les informations",
        "plan": {
            "menu_name": "Abonnements",
            "title": "Mes abonnements"
        },
        "secret": {
            "menu_name": "Ma clé secrète",
            "reload": "Générer un nouveau code",
            "subtitle": "C'est une clé que vous pouvez régénérer à n'importe quel moment, elle peut vous être demandée pour valider une action sensible lors de votre navigation. Vous devriez la mémoriser !",
            "title": "Votre clé secrète"
        },
        "title": "Informations du compte",
        "undo": "Verrouiller les informations",
        "user": {
            "menu_name": "Identifiants",
            "right": {
                "card": {
                    "moderator": "Modérateur"
                },
                "title": "Votre carte de visite"
            },
            "title": "Informations du compte"
        }
    },
    "bookmarks": {
        "delete_dialogue": {
            "cancel": "Annuler",
            "ok": "Effacer",
            "title": "Suppression de votre favori"
        },
        "list": {
            "actions": "Actions",
            "delete": "Effacer cette ligne",
            "dt": "Ajouté le",
            "edit": "Modifier cette ligne",
            "search": "Filtrage",
            "title": "Description",
            "url": "Page web"
        },
        "update_dialogue": {
            "cancel": "Abandonner",
            "ok": "Enregister",
            "title": "Modification de votre favori"
        }
    },
    "charts": {
        "statistics": {
            "likes": "Nombre de mentions j'aime",
            "names": {
                "progression": "Evolution sur trois mois",
                "raw": "Dernières mesures journalières"
            },
            "prints": "Nombre d'impressions",
            "publications": "Nombre de publications"
        }
    },
    "common": {
        "accept": "Accepter",
        "add": "Ajouter",
        "back": "Précédent",
        "cancel": "Annuler",
        "close": "Fermer",
        "continue": "Continuer",
        "copyClipBoard": "Copier vers le presse papier",
        "delete": "Supprimer",
        "form": {
            "avatar": {
                "errors": {
                    "upload": "Mise à jour de votre avatar impossible, merci de vérifier le format de votre fichier"
                },
                "text": "Changer l'avatar"
            },
            "logo": {
                "errors": {
                    "upload": "Mise à jour de votre logo impossible, merci de vérifier le format de votre fichier"
                },
                "text": "Changer votre logo"
            },
            "drag_and_drop": {
                "label": "Déposez vos fichiers ici !",
                "size_error": "Le fichier est trop volumineux !",
                "type_error": "Le type de fichier fournit est incorrect ! Fichiers autorisés : {type}"
            }
        },
        "locale": "Langue",
        "menu": "Menu",
        "months": {
            "april": "Avril",
            "august": "Août",
            "december": "Décembre",
            "february": "Février",
            "january": "Janvier",
            "july": "Juillet",
            "june": "Juin",
            "march": "Mars",
            "may": "Mai",
            "november": "Novembre",
            "october": "Octobre",
            "september": "September"
        },
        "more": "Afficher plus...",
        "next": "Suivant",
        "no": "Non",
        "no_results": "Pas d'éléments disponibles pour le moment",
        "not_required": "optionnel",
        "optional": "Optionnel",
        "preview": "Aperçu",
        "previous": "Précédent",
        "readonly": "non modifiable",
        "save": "Sauvegarder",
        "skip": "Passer",
        "update": "Mettre à jour",
        "yes": "Oui"
    },
    "company": {
        "address": {
            "step": "Adresse"
        },
        "basics": {
            "step": "Enregistrement"
        },
        "confirmation": {
            "step": "Email de confirmation"
        },
        "details": {
            "step": "Détails"
        },
        "entity": {
            "menu_name": "Mes informations",
            "title": "Informations sur mon entreprise"
        },
        "form": {
            "category": "Secteur d'activité",
            "city": "Ville",
            "company_name": "Nom de l'entreprise",
            "country": "Pays",
            "department": "Département",
            "email": "Email",
            "employees": "Nombre d'employés",
            "first_name": "Prénom",
            "further_information": "Complément",
            "last_name": "Nom",
            "phone": "Téléphone",
            "siret": "SIRET",
            "street": "Rue",
            "zip": "Code postal",
            "headline": "Slogan de votre entreprise",
            "public_name": "Nom public de votre site"
        },
        "information": {
            "step": "Informations",
            "text": "En suivant les étapes de ce formulaire, vous pourrez accéder à la modération des avis de vos sites."
        },
        "invoices": {
            "actions": "Voir/Télécharger la facture",
            "created_at": "Date",
            "menu_name": "Mes factures",
            "name": "Nom",
            "none_selected": "Sélectionnez une facture pour la visualiser",
            "number": "Numéro",
            "price_gross": "Montant TTC",
            "price_net": "Montant HT",
            "refresh": "Rafraîchir la liste des factures",
            "title": "Mes factures"
        },
        "plan": {
            "menu_name": "Mes abonnements",
            "noSubscription": "Vous n'avez actuellement aucun abonnement payant en cours.",
            "title": "Gérer mes abonnements"
        }
    },
    "dashboard": {
        "account": {
            "menu_tooltip": "Compte\n- Identifiants\n- Entreprise\n- Abonnements\n- Factures",
            "title": "Mon\nCompte"
        },
        "company": {
            "address": "Adresse",
            "identification": "Identification de l'entreprise",
            "manager": "Personne à contacter (pour la facturation)",
            "plan": {
                "amount": "Montant",
                "available": "Abonnements disponibles",
                "available_tokens": "Aucun site attaché sur {amount} | {used} site attaché sur {amount} | {used} sites attachés sur {amount}",
                "billingLabel_0": "mensuelle",
                "billingLabel_1": "annuelle",
                "billingTranslation": "Reconduction {billing}",
                "counter": "Crédits disponibles :",
                "created_at": "Date et heure de la transaction ",
                "discountTranslation": ", avec une réduction de <strong>{discount}</strong>.",
                "from": "Abonné depuis ",
                "list": {
                    "title": "Mes abonnements"
                },
                "modal": {
                    "create": {
                        "isFree": "L'abonnement FREE est toujours inclus",
                        "pay": "Payer mon abonnement",
                        "title": "Nouvel abonnement"
                    },
                    "ordered": {
                        "cancel": "Fermer",
                        "status": {
                            "0": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Attention<br><br>Nous vous remercions d'avoir passé commande.<br><br>Pour le moment nous n'avons par reçu de confirmation de la réception de votre règlement.<br><br>Vous serez informé par email dès sa réception.",
                            "1": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Attention<br><br>Nous vous remercions d'avoir passé commande.<br><br>Votre règlement ne nous est pas encore parvenu.<br><br>Vous serez immédiatement informé par email lors de la réception.",
                            "2": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Attention<br><br>Nous vous remercions d'avoir passé commande.<br>Malheuresement le règlement a échoué.<br><br>Nous vous invitons a renouveller votre règlement.",
                            "3": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Attention<br><br>Malheuresement cet abonnement a été annulé.<br><br>Nous vous invitons a renouveller simplement votre abonnement.",
                            "4": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Attention<br><br>Le règlement correspondant à votre commande n'a pas pu être pris en compte.<br>Vous pouvez simplement refaire une nouvelle tentative.",
                            "5": "<i class='fas fa-check succes--text font-weight-bold'></i> Votre demande a bien été prise en compte<br><br>Le règlement correspondant à votre commande a bien été remboursé.<br><br>Encore merci de votre confiance.",
                            "6": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Attention<br><br>Le règlement correspondant à votre commande n'a pas encore été reçu.<br><br>Vous serez immédiatement informé par email lors de la réception.",
                            "7": "<i class='fas fa-check succes--text font-weight-bold'></i> Votre demande a bien été prise en compte<br><br>Nous vous remercions d'avoir passé commande.<br>Vous pouvez désormais attribuer cet abonnement à vos sites.<br><br>Pour cela rendez-vous dans l'onglet <strong>Sites</strong>.",
                            "unknown": "<i class='fas fa-exclamation-circle warning--text font-weight-bold'></i> Attention<br><br>Votre commande n'a pas pu être finalisée,<br><br>notre service commercial a été informé et reviendra vers vous le plus rapidement possible.<br><br>Vous pouvez aussi simplement refaire une nouvelle tentative."
                        },
                        "title": "Confirmation de votre commande"
                    },
                    "update": {
                        "cancel": "Annuler la reconduction automatique",
                        "nothing": "Aucune action possible sur cet abonnement pour le moment.",
                        "title": "Modification de l'abonnement"
                    }
                },
                "next": "prochaine échéance le ",
                "noDiscountTranslation": ". Avec la reconduction annuelle, profitez d'une réduction immédiate.",
                "order": "Ajouter un abonnement",
                "planColor_0": "grey",
                "planColor_1": "orange",
                "planColor_2": "green",
                "planColor_3": "blue",
                "planColor_4": "yellow",
                "planIcon_0": "fa-child",
                "planIcon_1": "fa-male",
                "planIcon_2": "fa-walking",
                "planIcon_3": "fa-running",
                "planIcon_4": "fa-biking",
                "planLabel_0": "Free",
                "planLabel_100": "Discover",
                "planLabel_1": "Start",
                "planLabel_2": "Smart",
                "planLabel_3": "Max",
                "planLabel_4": "No-limit",
                "planStatus_0": "Abonnement à régler",
                "planStatus_1": "En attente du règlement",
                "planStatus_2": "Règlement échoué",
                "planStatus_3": "Règlement expiré",
                "planStatus_4": "Paiement abandonné",
                "planStatus_5": "Abonnement remboursé",
                "planStatus_6": "Abonnement en attente de règlement",
                "planStatus_7": "Abonnement en cours",
                "planTranslation": "Abonnement <strong>{plan}</strong>",
                "preview": {
                    "qte": "Qté",
                    "ref": "Réf",
                    "total_vat_excluded": "Total HT",
                    "total_vat_included": "Total TTC",
                    "vat_amount": "Montant TVA",
                    "vat_excluded": "PU HT",
                    "vat_rate": "TVA"
                },
                "refresh": "Rafraîchir la liste des abonnements",
                "secure_by_mollie": "Paiement sécurisé et effectué par",
                "selected": "Offre d'abonnement choisie",
                "total": "Aperçu de la facturation",
                "until": "abonnement actif jusqu'a la date du ",
                "viewAllSubsciption": {
                    "setToFalse": "Voir uniquement les abonnements en cours",
                    "setToTrue": "Voir tous les abonnements"
                },
                "woTva": "HT"
            },
            "title": "Entreprise"
        },
        "documentation": {
            "title": "Documentation"
        },
        "extension": {
            "title": "Télécharger l'extension"
        },
        "feed": {
            "title": "Actualités"
        },
        "formsInputErrors": "Merci de corriger les erreurs suivantes",
        "groups": {
            "title": "Groupes"
        },
        "help": {
            "hide": "Masquer l'aide",
            "hide_menu_name": "Masquer l'aide",
            "show": "Afficher l'aide",
            "show_menu_name": "Afficher l'aide",
            "title": "Aide"
        },
        "invitation": {
            "menu_tooltip": "invitations\n- Suivi des invitations\n- Création d'une invitation\n- Identifier mes clients",
            "title": "Invitations",
            "tracking": {
                "menu_name": "Suivi des invitations",
                "metas": "Meta-informations asscociées",
                "title": "Suivi des invitations"
            }
        },
        "navigation": {
            "close": "Fermer l'onglet",
            "maximize": "Agrandir le menu",
            "minimize": "Réduire le menu"
        },
        "notifications": {
            "title": "Notifications"
        },
        "parameters": {
            "menu_tooltip": "Configuration\n- Liste des profils\n- Diffusion des avis",
            "title": "Mes\nParamètres"
        },
        "products": {
            "menu_tooltip": "Produits\n- Mes produits\n- Ajouter un produit\n- Importer mes produits\n- Mes Marques",
            "title": "Mes\nProduits"
        },
        "qualify": {
            "title": "Qualification"
        },
        "ranking": {
            "created": "Membre depuis",
            "publications": "Publications",
            "title": "Classement"
        },
        "refresh": "Recharger la liste",
        "reviews": {
            "generation": {
                "form": {
                    "all": "Voir l'ensemble des avis.",
                    "submit": "Générer la liste"
                },
                "infos": "Informations",
                "list": "Voir la liste",
                "menu-title": "Génération",
                "title": "Ma liste des avis"
            },
            "menu_tooltip": "Avis\n- Avis sites\n- Avis produits",
            "title": "Mes avis"
        },
        "reviewsModeration": {
            "deadlock": "La publication est verrouillée par un autre utilisateur ({date}).\n<br> Merci de retenter dans quelques instant votre tentative.",
            "dialogs": {
                "cancel": {
                    "text": "Confirmez-vous l'annulation des modification en cours ?",
                    "title": "Annulation"
                },
                "publish": {
                    "success": "L'avis à bien été publié",
                    "text": "Confirmez-vous le passage de cet avis en public ?",
                    "title": "Statut de modération"
                },
                "remove": {
                    "text": "Confirmez-vous la suppression de l'avis ? Vous ne pourrez pas revenir en arrière.",
                    "title": "Confirmation"
                },
                "report": {
                    "success": "L'avis à bien été rejeté",
                    "text": "Souhaitez-vous signaler cet avis ?\n Le niveau de confiance de l'avis diminuera drastiquement et ne sera pas affiché. <br>\nAttention ! Signaler un avis pour de mauvaises raisons peut faire l'objet de sanctions.\n",
                    "title": "Signaler un avis"
                }
            },
            "filters": {
                "confidence": "Niveau de confiance de l'avis",
                "created_at": "Date de publication",
                "order": {
                    "asc": "Décroissant",
                    "desc": "Croissant"
                },
                "rating": "Note de l'internaute",
                "title": "Organiser la liste des avis",
                "title_order": "Classement de la liste",
                "title_sort": "Trier par"
            },
            "generation": {
                "at": "à",
                "documentation": "Documentation du module de modération",
                "form": {
                    "from": "Avis à partir du",
                    "group": "Groupe de modérateurs",
                    "moderate": "Inclure les avis déjà modérés",
                    "submit": "Créer la liste"
                },
                "generate_menu_name": "Créer la liste des avis",
                "generated": "Création en cours",
                "infos": "Informations",
                "last_generate": "Dernière création",
                "last_refresh": "Dernier chargement",
                "list": "Voir la liste",
                "menu-title": "Génération",
                "processing": "Votre demande a bien été prise en compte, son traitement peut prendre quelques secondes. Utilisez le bouton <b>'RAFRAICHIR LA LISTE'</b> pour charger votre liste de publications.",
                "refresh_menu_name": "Rafraîchir la liste des avis",
                "title": "Créer la liste des avis"
            },
            "list": {
                "confidence": "Niveau de confiance de l'avis",
                "created_at": "Date de rédaction",
                "empty": {
                    "criteres": "Vos critères :",
                    "fromDate": "Publication créée après la date du :",
                    "messageEmptyResult": "Malheuresement, aucune publication ne correspond à votre demande!",
                    "moderated_no": "Publication non modérée",
                    "moderated_yes": "Publication déjà modérée",
                    "refreshAllReadyNotDone": "Aucune information n'est disponible pour le moment.",
                    "requestDateTime": "Date et heure de la demande "
                },
                "like_counter": "{n} j'aime | {n} j'aimes",
                "moderate": "Statut de la modération",
                "moderated": "Modéré",
                "not-moderated": "Non modéré",
                "private": "Note personnelle",
                "rating": "Note de l'avis",
                "rejected": "Rejeté",
                "title": "Liste des avis",
                "updated_at": "Date de la dernière mise à jour"
            },
            "refresh": {
                "reload": "Charger la liste",
                "title": "Charger de la liste"
            },
            "response": {
                "buttons": {
                    "back": "Précédent",
                    "cancel": "Annuler les modifications",
                    "delete": "Supprimer la réponse",
                    "edit": "Editer la réponse",
                    "publish": "Publier l'avis",
                    "reply": "Répondre",
                    "report": "Rejeter l'avis",
                    "update": "Suivant"
                },
                "context": {
                    "from_order": "Avis d'un Influenceur ou d'un  Client ?",
                    "from_order_false": "Influenceur.",
                    "from_order_true": "Client",
                    "gift_description": "Description de la contrepartie",
                    "hashtag": "Associer un Hashtag",
                    "hashtag_help": "Un mot unique en majuscule qui permet le groupement de vos avis.",
                    "order_date": "Date de la commande",
                    "order_info_type_service": "Informations sur le service",
                    "order_item_code": "Référence commandée",
                    "order_item_desc": "Nom du produit/service",
                    "order_item_type": "La commande concerne",
                    "order_item_type_product": "Un produit",
                    "order_item_type_service": "Un service",
                    "order_mandatory_info": "Informations obligatoires",
                    "order_number": "Numéro de commande",
                    "order_optional_info": "Informations complémentaires de la commande",
                    "order_service_begin": "Date de début",
                    "order_service_end": "Date de fin",
                    "with_gift": "Avis avec une contrepartie ?",
                    "with_gift_false": "Non",
                    "with_gift_true": "Oui",
                },
                "message": "Donnez une réponse (optionnel)",
                "message_help": "Comme par exemple des remerciements, des explications complémentaires, etc...",
                "pertinence": "Pertinence de l'avis",
                "publish": "Notez la pertinence de l'avis",
                "report": {
                    "1": "Grossier ou vulgaire",
                    "2": "Discrimination, incitation à la haine",
                    "3": "Humiliation publique",
                    "4": "Spam",
                    "5": "Contenu commercial ou auto-promotion",
                    "6": "Message relevant de la communication privée",
                    "7": "Problème de sécurité, de fraude ou de légalité",
                    "8": "Menace l’intégrité physique d’une personne",
                    "9": "Violation de la vie privée d'une personne",
                    "label": "Motif du rejet",
                    "title": "Signaler l'avis"
                },
                "title": "Validez l'avis",
                "update_date": "{date}",
                "locale": "Langue d'origine de l'avis"
            },
            "response_done": {
                "buttons": {
                    "change": "Re-valider cet avis"
                },
                "message": "Réponse actuellement visible",
                "moderation_done": "L'avis de votre client a bien été traité",
                "no_message": "Vous n'avez pas donné de réponse",
                "pertinence": "Pertinence de l'avis",
                "publish": "Publier l'avis pour le rendre visible",
                "report": {
                    "1": "Grossier ou vulgaire",
                    "2": "Discrimination, incitation à la haine",
                    "3": "Humiliation publique",
                    "4": "Spam",
                    "5": "Contenu commercial ou auto-promotion",
                    "6": "Message relevant de la communication privée",
                    "7": "Problème de sécurité, de fraude ou de légalité",
                    "8": "Menace l’intégrité physique d’une personne",
                    "9": "Violation de la vie privée d'une personne",
                    "label": "Motif du rejet",
                    "title": "Signaler l'avis"
                },
                "title": "Mise à jour de cet avis",
                "update_date": "{date}"
            },
            "review": {
                "body": "Lien de moderation -> {url}",
                "buttons": {
                    "cancel": "Annuler les modifications",
                    "delete": "Supprimer l'avis",
                    "edit": "Modifier l'avis",
                    "update": "Modifier l'avis"
                },
                "card_title": "Détails de l'avis",
                "copied": "Le lien de modération à été copié dans votre presse-papier !",
                "edit": "Éditer l'avis",
                "external": "Voir l'avis sur le site",
                "link": "Copier un lien de modération",
                "mailto": "Envoyer ce lien par email",
                "message": "Message",
                "response": "Réponse",
                "review": "Avis",
                "review_link": "Visualiser l'avis sur le site",
                "solicitation": "Collecté à l'aide d'une invitation",
                "not_solicitation": "Avis libre",
                "customer_without_solicitation": "Avis libre (identifié avec un client)",
                "subject": "Voici un lien pour modérer un avis.",
                "title": "Titre",
                "update_date": "Avis modifié par l'utilisateur le {date}",
                "viewSolicitation": "Consulter l'invitation",
                "order_date" : "Date de commande",
                "order_number" : "Numéro de commande",
            },
            "tabs": {
                "author": "Auteur",
                "gift": "Contrepartie",
                "hashtag": "Hashtag",
                "order": "Commande",
                "response": "réponse"
            },
            "title": "Avis"
        },
        "social": {
            "title": "Invitations"
        },
        "statistics": {
            "menu_tooltip": "Statistiques\n- Suivi des invitations"
        },
        "stories": {
            "menu_tooltip": "Stories\n- Stories",
            "title": "Stories"
        },
        "suggestions": {
            "menu_tooltip": "Suggestions\n- Vos pages\n- Paramétrages",
            "title": "Suggestions"
        },
        "urls": {
            "title": "Pages"
        },
        "userGroups": {
            "title": "Groupes"
        },
        "wall": {
            "title": "Page personnelle"
        },
        "websites": {
            "menu_tooltip": "Sites\n- Mes sites\n- Page personnelle",
            "title": "Mes\nSites"
        }
    },
    "documentation": {
        "editor": {
            "dialog": {
                "title": "Aperçu de la documentation"
            },
            "form": {
                "path": "Chemin vers la documentation (unique)"
            },
            "path": "Identifiant unique",
            "remove": "Supprimer",
            "reset": "Nouveau",
            "save": {
                "error": "Sauvegarde impossible",
                "success": "Sauvegardé"
            },
            "title": "Identification de la documentation",
            "toolbar": {
                "bold": "Gras",
                "clear": "Effacer le contenu",
                "code": "Code",
                "comment": "Commentaires",
                "fullscreen": "Mode plein écran",
                "heading": "Titre",
                "help": "Comprendre le markdown",
                "image": "Image",
                "italic": "Italique",
                "link": "Lien",
                "ol": "Liste ordonnée",
                "preview": "Aperçu",
                "quote": "Citation",
                "strikethrough": "Barré",
                "table": "Tableau",
                "ul": "Liste à puces",
                "youtube": "YouTube"
            }
        },
        "empty": "<b>Documentation : </b><b class='red--text'>{path}</b><br><br> Cette documentation n'est pas rédigée pour le moment.",
        "menu_name": "Aide à l'utilisation",
        "preview": {
            "title": "Aide et documentation"
        },
        "title": "Documentation et aide à l'utilisation"
    },
    "feed": {
        "product": {
            "intro": {
                "manager": "Avis concernant le produit",
                "me": "L'avis concerne le produit"
            }
        },
        "thematic": {
            "intro": {
                "manager": "Avis concernant",
                "me": "L'avis concerne"
            }
        },
        "top": {
            "menu_name": "Classement des contributeurs",
            "title": "Classements des meilleurs contributeurs"
        },
        "user": {
            "menu_name": "Publications d'un utilisateur"
        },
        "wall": {
            "menu_name": "Mon fil d'actualité",
            "title": "Votre fil d'actualité"
        }
    },
    "form": {
        "errors": {
            "62ab17c4-407a-11eb-8a64-9ff6b4495c19": "Ce pseudo est déjà utilisé.",
            "7cd5874c-407a-11eb-8647-3730f1b86ed8": "Une erreur est survenue lors de la création de votre compte, merci de réessayer plus tard.",
            "7eab69d0-4078-11eb-9248-4328374c61e3": "L'adresse email est déjà utilisée.",
            "E000000": "Erreur inconnue",
            "E100000": "Erreur du manager",
            "E110000": "Erreur du manager pro",
            "E111000": "Erreur du manager pro / Registration",
            "E111001": "La création est impossible car un compte existe déjà avec cet email",
            "E111002": "La création de votre compte est impossible car votre pseudo a déjà été réservé par un autre utilisateur",
            "E120000": "Erreur du manager perso",
            "E200000": "Erreur de l'api",
            "E210000": "Erreur du micro service publication",
            "E220000": "Erreur du micro service suggestion",
            "E230000": "Erreur du micro service robot",
            "label": "Erreur"
        },
        "fields": {
            "birth_date": "Date de naissance",
            "company_name": "Nom de l'entreprise",
            "email": "Email",
            "first_name": "Prénom",
            "landline": "numeric|nullable|max:15",
            "last_name": "Nom",
            "mobile_phone": "numeric|nullable|max:15",
            "phone": "Telephone",
            "vat_number": "Numéro de TVA intracommunautaire"
        },
        "key": "Clé",
        "keys": "Clés",
        "validation": {
            "alpha": "Uniquement des lettres attendues",
            "before": "La date semble érronée",
            "numeric": "Uniquement des chiffres attendus"
        },
        "value": "Valeur",
        "values": "Valeurs"
    },
    "groups": {
        "form": {
            "add": "Ajouter",
            "title": "Lancer un nouveau groupe"
        }
    },
    "invitation": {
        "csv": {
            "convert": "Envoyer votre fichier",
            "copied": "Le contenu du fichier CSV à été copié !",
            "dialog": {
                "copy": "Copier",
                "download": "Télécharger",
                "title": "Vos fichiers CSV enrichis"
            },
            "drag_and_drop": "Vos fichiers CSV",
            "filters": {
                "include_securating_accounts": "Exclure les comptes Securating actifs",
                "title": "Filtrage"
            },
            "menu_name": "Créer plusieurs invitations",
            "options": {
                "send_file": "Télécharger uniquement votre fichier enrichi",
                "send_mail": "Envoyer automatiquement un email à chaque contact de votre fichier",
                "title": "Options"
            },
            "title": "Transfert de votre fichier d'emailing pour la collecte de vos avis",
            "upload_error": "Une erreur est survenue au moment d'envoyer les fichiers. Merci de réessayer."
        },
        "dialogs": {
            "url": {
                "title": "Votre lien d'invitation"
            }
        },
        "emailing": {
            "bt": {
                "clear": "Effacer le formulaire",
                "send": "Créer une invitation"
            },
            "form": {
                "company_name": "Nom de d'entreprise à afficher",
                "customer_avatar": "Url du logo de votre client",
                "customer_bio": "Poste occupé",
                "customer_gender": "Civilité",
                "customer_link": "Site web de votre client",
                "email": "Adresse email",
                "first_name": "Prénom",
                "last_name": "Nom de famille",
                "path": "Adresse web de la page de collecte (doit débuter avec un '/')",
                "product": "Code produit (25:0001)",
                "template_mail": "Modèle de l'email",
                "thematics": "Codes thèmatiques de sondage (100100,100200)",
                "url": "https://votre-site.com/votre-page"
            },
            "gift_description": "Description de la contrepartie",
            "hashtag": "Hashtag",
            "locale": "Langue de l'email d'invitation",
            "mail": {
                "nok": "Une erreur est survenu! Votre invitation n'a pas pu être envoyée",
                "ok": "Votre invitation a bien été envoyée à "
            },
            "mail_delay": "Délai avant l'envoi du premier email",
            "mail_delay_input": "Délai en jours",
            "menu_name": "Créer une invitation",
            "options": {
                "send_mail": "Envoyer l'invitation à votre contact par email",
                "send_url": "Télécharger l'url d'invitation",
                "title": "Options"
            },
            "title_about": "Type d'information à collecter",
            "title_about_choice" : "Avis site / Produit / Sondage ",
            "options_type": {
                "pro": "Avis produit",
                "pro_son": "Avis produit avec sondage",
                "ser": "Avis site",
                "ser_son": "Avis site avec sondage",
                "son": "Sondage uniquement"
            },
            "title_external": "Lien de collecte à inclure dans l'invitation",
            "title_external_choice": "Securating / Lien externe / Tout",
            "options_external_link": {
                "no" : "Uniquement le lien Securating",
                "only" : "Uniquement le lien externe",
                "both" : "Inclure les deux liens"
            },
            "order_date": "Date de la commande",
            "order_item_code": "Référence",
            "order_item_desc": "Description commerciale",
            "order_item_type": "Object de la commande",
            "order_item_type_product": "Commande de produits",
            "order_item_type_service": "Commande de service",
            "order_number": "N° de la commande",
            "order_service_begin": "Date de début du service",
            "order_service_end": "Date de fin",
            "profile": "Modérateur",
            "profiles": "Modérateur",
            "recall_count": "Renvoi de l'email d'invitation",
            "recall_count_input": "Nombre de relances",
            "recall_delay": "Délai entre deux relances",
            "recall_delay_input": "Délai en jours",

            "step_modele": "Modèle de l'email",
            "step_moderator": "Modérateur",
            "step_periode": "Relances et délais",

            "step_names": "Destinataire",

            "step_type": "Paramètres de l'invitation",
            "step_order": "Commande",
            "step_url": "Url de collecte",
            "title": "Création d'une invitation: (Avis client, Avis produit, Sondage)",

            "title_customer": "Personne invitée à donner son avis",
            "title_customer_pro": "Informations professionnelles ?",
            "title_from": "Url de collecte de l'avis",
            "title_locale": "Langue et modèle du mail",
            "title_order": "Informations sur la commande",
            "title_profile": "Profil du modérateur à l'origine de la demande",
            "title_who": "Nom de l'entreprise pour laquelle l'avis est collecté",
            "url": {
                "nok": "Une erreur est survenu! Votre lien d'invitation n'a pas pu être construit",
                "ok": "Votre lien d'invitation a bien été construit"
            },
            "website": "Site de collecte",
            "website_not_selected": "Sélectionnez un site pour continuer",
            "with_gift": "Avis a été en échange d'une contrepartie"
        },
        "manual": {
            "menu_name": "Identifier mes clients",
            "title": "Recherche et identification de vos clients parmi les utilisateurs de Securating"
        },
        "title": "Invitations",
        "tracking": {
            "cancel": "Annuler la demande",
            "canceled_at": "Date d'annulation",
            "close": "Fermer",
            "created_at": "Date de l'invitation",
            "delete": "Effacer la demande",
            "confirm_domain": "Confirmer l'avis site",
            "confirm_product": "Confirmer l'avis produit",
            "confirm_thematic": "Confirmer l'avis thématique",
            "email": "Email du client",
            "link": "Lien vers l'invitation",
            "list": {
                "created_at": "Date de génération de l'invitation",
                "infos": {
                    "1": "Janvier",
                    "2": "Février",
                    "3": "Mars",
                    "4": "Avril",
                    "5": "Mai",
                    "6": "Juin",
                    "7": "Juillet",
                    "8": "Août",
                    "9": "Septembre",
                    "10": "Octobre",
                    "11": "Novembre",
                    "12": "Décembre",
                    "not_pending": "Avis déposés",
                    "pending": "Invitations sans réponses",
                    "percentage": "Taux de réponses",
                    "title": "Statistiques sur les trois dernière mois",
                    "total": "Nombre d'invitations"
                },
                "moderated": "Opération finie",
                "not_moderated": "En cours",
                "title": "Liste de vos dernières invitations",
                "keywords": "Recherchez avec quelques mots clés",
                "websites": "Choisissez un site"
            },
            "mail_1_resend_at": "Première relance",
            "mail_2_resend_at": "Seconde relance",
            "mail_3_resend_at": "Dernière relance",
            "mail_delay": "Délai initial avant envoi du premier email",
            "mail_delay_format": "Aucun | {n} jour | {n} jours",
            "mail_next_resend_at": "Prochaine relance",
            "mail_resent_nb": "Nombre de relances restantes",
            "menu_name": "Suivi des invitations",
            "meta_data": "Meta data associés",
            "meta_data_custom": "Autres",
            "meta_data_customer": "A votre client",
            "meta_data_gift": "A la contrepartie",
            "meta_data_metas": "A votre demande",
            "meta_data_order": "A la commande",
            "name": "Nom du client",
            "no_more_resend": "Aucune",
            "order": "Référence commande",
            "ordered_at": "Date de commande",
            "product": "Produit concerné",
            "profile": "Modérateur",
            "row": "Cliquez pour voir le détail de l'invitation",
            "table": {
                "client": "Client",
                "created_at": "Date d'invitation",
                "mail_account": "Email de vérification envoyé",
                "mail_account_verified": "Publication vérifiée par le client",
                "mail_clicked": "Lien d'invitation ouvert",
                "mail_send": "Premier email envoyé",
                "profile": "Profile modérateur",
                "publication_moderated": "Publication modérée",
                "token_used": "Publication déposée",
                "need_revalidate": "Publication à confirmer",
                "is_revalidated": "Publication confirmée"
            },
            "thematics": "Thématiques concernées",
            "title": "Suivi de vos invitations",
            "revalidate" : {
                "title" : "Re-confirmation de l'avis",
                "revalidate_type" : "Type d'avis à reconfirmer",
                "revalidate_type_D" : "Avis site",
                "revalidate_type_P" : "Avis produit",
                "revalidate_type_T" : "Avis thématique",
                "revalidate_type_A" : "Tous les type d'avis",
                "need_revalidate_true" : "Vous avez demandé une re-confirmation de l'avis",
                "need_revalidate_false" : "Aucune demande de re-confirmation n'a été demandée",
                "is_revalidated_true" : "Le contenu de l'avis a bien été re-confirmé par son auteur",
                "is_revalidated_false" : "Le contenu de l'avis n'a pas encore été re-confirmé par son auteur",
                "revalidated_at" : "Date de confirmation ",
            }
        }
    },
    "locales": {
      "fr": "Français",
      "en": "Anglais",
      "es": "Espagnol",
      "it": "Italien",
      "de": "Allemand",
      "xx": "Autres",
    },
    "login": {
        "error": "Erreur lors de la connexion, adresse email ou mot de passe incorrect !",
        "form": {
            "email": {
                "label": "Adresse email ou Pseudo"
            },
            "password": {
                "label": "Mot de passe"
            },
            "recover": "Mot de passe perdu ?",
            "registration": "Créer mon compte",
            "registration_pro": "Créer mon compte"
        },
        "go": {
            "access": "Accès",
            "access_title": "Allez sur le portail ",
            "manager": "Entreprise",
            "me": "Internaute"
        },
        "return": "J'ai déjà un compte",
        "submit": "Connexion",
        "title": "Connexion"
    },
    "manager": {
        "moderation": {
            "errors": {
                "token_expiration": {
                    "link": "Retourner sur mon espace",
                    "message": "Le lien de modération à expiré, les liens expirent automatiquement après 4 jours. Vous pouvez retourner dans votre espace pour en générer un nouveau à tout moment.",
                    "title": "Oops, une erreur est survenue !"
                }
            },
            "reviews": {
                "filter_both": "Peu importe",
                "filter_no": "Non",
                "filter_marked": "Identifée",
                "filter_undefined": "Sans informations",
                "filter_yes": "Oui",
                "from_order": "Avec commande: ",
                "generate_list": "Recherche",
                "moderated": "Afficher les avis :",
                "moderated_published": "Publiés",
                "moderated_rejected": "Rejetés",
                "not_moderated": "Non modérés",
                "search": "Recherche par mots-clés",
                "search_hashtag": "Rechercher dans les #Hashtag",
                "search_keywords": "Saisissez votre recherche ici",
                "search_no": "Pas de recherche",
                "search_products": "Recherche dans les produits",
                "search_publications": "Rechercher dans les avis",
                "search_users": "Recherche par utilisateur",
                "title": "Recherche par mots-clés",
                "title_filter_data": "Filtrage par context",
                "title_filter_state": "Recherche par état",
                "websites": "Choisissez un site à modérer",
                "with_gift": "Avec contrepartie: ",
                "locale": "Avec langue: ",
                "with_solicitation": "Avec invitation: "
            }
        },
        "websites": {
            "list": "Choisissez un site",
            "selected": "Site sélectionné",
            "title": "Sélection du site"
        }
    },
    "me": {
        "pages": {
            "validation_token": {
                "collect_publication": "Votre publication a bien été prise en compte.",
                "invalid_token": "Action impossible, merci de vérifier votre lien, celui-ci semble incorrect.",
                "title": "Confirmation de votre publication"
            }
        }
    },
    "menu": {
        "bookmark": {
            "list": {
                "actions": "Actions",
                "dt": "date",
                "tags": "Mots clés",
                "url": "Page web"
            },
            "menu_name": "Mes favoris",
            "title": "Classer mes sites favoris"
        },
        "company": {
            "menu_name": "Menu principal",
            "right": {
                "title": "Statistiques"
            },
            "title": "Menu principal"
        },
        "documentation": {
            "menu_name": "Documentation",
            "title": "Documentation"
        },
        "groups": {
            "add": "Ajouter au groupe",
            "admin": "Administrateur",
            "edit": "Cliquez sur un groupe pour le modifier ou ajouter des personnes au groupe",
            "editing": {
                "avatar": "Avatar (url)",
                "description": "Description",
                "members": "Chercher des membres à ajouter",
                "title": "Nom"
            },
            "isAdmin": "Actuellement administrateur",
            "leave": "Quitter le groupe",
            "members": "Membres du groupe",
            "menu_name": "Mes groupes",
            "promote": "Promouvoir comme administrateur",
            "remove": "Sortir le membre du groupe",
            "right": {
                "title": "Informations du groupe"
            },
            "title": "Gérer mes groupes",
            "updated": "💾 &nbsp; Les informations du groupe ont bien été mises à jour"
        },
        "logoutDialogue": {
            "text": "Souhaitez vous réellement vous déconnecter ?",
            "title": "Confirmation ?"
        },
        "noPermission": "Vous n'avez pas accès à cette fonctionnalité.",
        "organized": {
            "grid": "Affichage grille",
            "row": "Affichage ligne"
        },
        "qualify": {
            "title": "Qualification"
        },
        "suggest": {
            "menu_name": "Mes sites",
            "title": "Proposer un site"
        },
        "suggestDialogue": {
            "host": "nom du site",
            "text": "Indiquez le nom du site que vous souhaitez voir ajouter a nos suggestions",
            "title": "Proposition de site"
        },
        "user": {
            "menu_name": "Tableau de bord",
            "title": "Mon tableau de bord"
        },
        "validate": {
            "list": {
                "action": "Actions",
                "date": "Date",
                "empty": "Rien à valider pour le moment.",
                "reject": "Rejeter",
                "title": "Titre",
                "type": "Type",
                "url": "Site",
                "validate": "Valider"
            },
            "menu_name": "Validation des publications",
            "title": "Valider mes publications",
            "type": {
                "1": "Avis",
                "2": "Média",
                "3": "Question",
                "4": "Réponse"
            }
        }
    },
    "messages": {
        "account": {
            "activation_allready": "Attention, votre compte a déjà été activé.",
            "activation_error": "Attention, votre compte est introuvable.",
            "activation_ok": "Votre compte a bien été activé."
        },
        "buttonGoBackOffice": "Allez dans votre espace personnel.",
        "defaultMessage": "Toute l'équipe vous remercie d'utiliser nos services.",
        "loadingDefault": "Chargement de vos informations"
    },
    "moderation": {
        "products": {
            "menu_name": "Avis produits"
        },
        "reviews": {
            "menu_name": "Avis sites"
        }
    },
    "notifications": {
        "list": {
            "menu_name": "Mes notifications",
            "title": "Notifications"
        }
    },
    "origin": {
        "av": "Avis vérfiés",
        "se": "Securating",
        "source": "Source de l'avis"
    },
    "parameters": {
        "profiles": {
            "cancel": "Annuler",
            "create": "Créer le profil",
            "created_at": "Date de création",
            "delete": "Supprimer le profil",
            "error": {
                "create_profile": "Erreur lors de la création du profil",
                "delete_profile": "Erreur lors de la suppression du profil",
                "fetch_counters": "Erreur lors du chargement des statistiques du profil",
                "fetch_profiles": "Erreur lors du chargement de la liste des profils",
                "update_profile": "Erreur lors de la mise à jour du profil"
            },
            "menu_name": "Liste des profils",
            "name": "Nom ou pseudo du modérateur",
            "new": "Nouveau profil",
            "nothing": "Aucun profil pour le moment",
            "public_id": "ID public du modérateur (non modifiable)",
            "refresh": "Rafraîchir la liste des modérateurs",
            "selected": "Profil du modérateur",
            "title": "Liste des profils modérateurs",
            "update": "Mettre à jour le profil",
            "updated_at": "Dernière mise à jour"
        },
        "reviews_params": {
            "menu_name": "Diffusion des avis",
            "title": "Paramétrage de la diffusion des avis sur vos sites"
        },
        "thematics_params": {
            "menu_name": "Sujets de sondages"
        },
        "title": "Configuration"
    },
    "pass": {
        "form": {
            "password": "Mot de passe"
        },
        "submit": "Changer mon mot de passe",
        "title": "Réinitialiser votre mot de passe"
    },
    "products": {
        "brand": {
            "accept_legals": "de confirmation",
            "add": "Ajouter une marque",
            "bsin": "Numéro d'identification standard de la marque (BSIN)",
            "cancel": "Retour",
            "description": "Description",
            "help": "Si votre marque ne figure pas dans la liste, merci de l'ajouter avant de renseigner vos produits.",
            "i_accept_legals": "Je certifie que cette marque m'appartient",
            "label": "Marques",
            "menu_name": "Mes marques",
            "name": "Nom de la marque",
            "owner": "*Vous ne pouvez pas modifier cette marque car elle n'est pas liée à votre compte.",
            "save": "Enregistrer",
            "title": "Informations sur mes Marques",
            "website": "Site web"
        },
        "product": {
            "add": "Ajouter un produit",
            "brand": "Marque du produit",
            "by_csv": "Via un fichier CSV",
            "by_form": "Via un simple formulaire",
            "cancel": "Fermer",
            "commercial_description": "Description commercial",
            "commercial_name": "Nom commercial",
            "create": "Créer mon produit",
            "drag_and_drop": "Votre fichier CSV",
            "ean": "Code public de votre produit (EAN, etc) ",
            "exclude_free": "Masquer les avis non sollicités",
            "get_error": "Impossible de charger la fiche de ce produit.",
            "help": "Vous pouvez créer, mettre à jour vos produits à partir d'un fichier CSV.",
            "help_bis": "Avant de créer des produits pensez à référencer votre marque.",
            "image_url": "Url de l'image miniature de ce produit",
            "product_url": "Url de la description du produit",
            "invitation_url": "Url à utiliser pour les invitations",
            "internal_code": "Code de référence interne",
            "is_sharable": "Les avis de ce produit sont uniquement affichés sur vos sites",
            "is_visible": "Les avis de ce produit ne sont pas diffusés",
            "list": "Vos produits",
            "product_familly": "Autres codes produits rattachés",
            "rate": "Calculer la note de mon produit",
            "review_description": "Texte d'aide à la collecte d'un avis",
            "send": "Envoyer le(s) fichier(s)",
            "title": "Ajoutez mes produits",
            "update": "Enregistrer et fermer",
            "upload_error": "Impossible de traiter vos fichiers, merci de vérifier leur structure (Voir la documentation)."
        },
        "product_add": {
            "menu_name": "Ajouter un produit",
            "title": "Ajoutez un produit"
        },
        "product_import": {
            "menu_name": "Importer mes produits",
            "title": "Importer mes produits"
        },
        "product_list": {
            "actions": {
                "delete": "Effacer ce produit",
                "edit": "Modifier ce produit",
                "view": "Charger les statistiques"
            },
            "list": "Index de vos produits",
            "list_info": "<select><option>Mon Produit-A</option><option>Mon Produit-B</option></select>",
            "menu_name": "Mes produits",
            "title": "Informations sur vos produits"
        },
        "product_statistics": {
            "details": "Répartition des avis clients par Notes",
            "no_data": "Aucune information disponible pour le moment.",
            "note_1": "avis clients ont reçu note de 1/5",
            "note_2": "avis clients ont reçu une note de 2/5",
            "note_3": "avis clients ont reçu une note de 3/5",
            "note_4": "avis clients ont reçu une note de 4/5",
            "note_5": "avis clients ont reçu une note de 5/5",
            "product": "Produit",
            "publicationsCount": "Nombre d'avis client",
            "rating": "Note moyenne",
            "selection_needed": "Sélectionnez un produit pour visualiser ses statistiques",
            "title": "Statistiques"
        },
        "product_update": {
            "menu_name": "Modifier un produit",
            "title": "Modifier un produit"
        }
    },
    "qualify": {
        "manual": {
            "bt": {
                "clear": "Effacer cette liste",
                "crypt": "Encrypter ma liste d'emails",
                "send": "Identifier cette liste"
            },
            "form": {
                "mails": "Liste des emails des comptes que vous souhaitez identifier (un email par ligne)",
                "title_website": "Site pour lequel vous souhaitez qualifier les auteurs de publications"
            },
            "messages": {
                "cryptDone": "Vos emails ont été cryptés, vous pouvez maintenant demander leur identification.",
                "cryptNotDone": "Certain emails ne semble pas valide, merci de les corriger.",
                "sendDoneError": "Une erreur c'est produite, merci de reformuler votre demande.",
                "sendDoneMore": "%d nouveaux auteurs ont été ajouté.",
                "sendDoneNone": "Aucun nouvel auteur n'a été ajouté.",
                "sendDoneOne": "Un nouvel auteur a été ajouté.",
                "sendDoneMorePublication": "%d nouveaux avis ont été marqués .",
                "sendDoneNonePublication": "Aucun nouvel avis n'a été marqué.",
                "sendDoneOnePublication": "Un nouvel avis a été marqué."
            },
            "title": "Recherche et identification de vos clients parmi les utilisateurs de Securating"
        }
    },
    "ranking": {
        "messages": {
            "loading": "Recherche des dernières publications de "
        }
    },
    "recover": {
        "emailing": "Nous vous avons <strong>envoyé</strong> un email pour réinitialiser votre mot de passe, merci de <strong>suivre le lien</strong> dans le corps de l'email.",
        "form": {
            "email": "Adresse email",
            "password": "Mot de passe"
        },
        "submit": "Recevoir un email",
        "title": "Mot de passe perdu ?"
    },
    "registration": {
        "contact": "Informations de contact de votre entreprise",
        "end": "Inscription terminée",
        "end_text": "Votre inscription est bien <b>terminée</b>. \n Merci d'activer votre compte via le <b>lien</b> que nous vous avons <b>envoyé par email</b>. <br><br>\n Vous pouvez ensuite vous connecter à votre compte en accédant au forumlaire de connexion en cliquant sur le bouton &laquo; <b>CONNEXION</b> &raquo; ci-dessous.",
        "form": {
            "company": {
                "address": {
                    "city": "Ville",
                    "country": "Pays",
                    "further_information": "Complément d'adresse",
                    "street": "Adresse",
                    "zip": "Code postal"
                },
                "category": "Secteurs d'activités",
                "company_name": "Nom de votre entreprise",
                "department": "Service",
                "email": "Adresse email de votre entreprise",
                "employees": "Effectif",
                "first_name": "Prénom",
                "host": "Nom de domaine ou site Internet",
                "id": "N° de compte Securating",
                "last_name": "Nom",
                "password": "Mot de passe",
                "phone": "Téléphone",
                "siret": "Numéro d'immatriculation (Siret,etc..)",
                "vat_number": "Numéro de TVA intracommunautaire (Entreprise Européenne)"
            },
            "legal": {
                "manager": {
                    "accept_legals": "conditions générales de vente",
                    "i_accept_legals": "En cliquant sur S’inscrire, vous acceptez nos",
                    "i_accept_newsletter": "Vous recevrez peut-être des notifications par email de notre part et vous pouvez à tout moment vous désabonner.",
                    "i_accept_privacy": "et notre",
                    "link_accept_legals": " Conditions générales de vente",
                    "link_accept_privacy": " Politique d’utilisation des données."
                },
                "me": {
                    "accept_legals": "conditions générales d'utilisation",
                    "i_accept_legals": "En cliquant sur S’inscrire, vous acceptez nos",
                    "i_accept_newsletter": "Vous recevrez peut-être des notifications par email de notre part et vous pouvez à tout moment vous désabonner.",
                    "i_accept_privacy": "et notre",
                    "link_accept_legals": " Conditions générales",
                    "link_accept_privacy": " Politique d’utilisation des données."
                }
            },
            "success": "Merci de consulter votre boîte email et cliquer sur le lien pour activer votre compte.",
            "user": {
                "email": "Adresse email",
                "password": "Mot de passe",
                "user_name": "Pseudo"
            }
        },
        "help": {
            "company": {
                "category": "Au premier clic, sélectionnez votre secteur d'activité. <br> Au second clic la précision. <br> Pour corriger votre saisie, cliquez à nouveau sur votre sélection.",
                "email": "Vous pouvez choisir d'utilier un email différent pour votre entité et votre compte de gestion. <br> Nous utiliserons cet adresse pour vous envoyer les notifications relatives à votre entité.",
                "host": "Si vous avez plusieurs site, notez ici le nom de domaine que vous souhaitez. <br> Une fois votre compte créé, allez dans \"menu\" puis \"site\" et complétez les noms des domaines restants.",
                "siret": "En choisissant de renseigner comme identifiant votre numéro Siret, <br> les champs suivants se remplissent automatiquement."
            }
        },
        "login": "Connexion",
        "more": "Informations complémentaires",
        "save_contact": "Enregistrer mes informations",
        "save_more": "Enregister mes informations",
        "save_site": "Enregister mon site",
        "signup": "M'inscrire",
        "site": "Mon site Internet principal",
        "skip_site": "Plus tard",
        "submit": "M'inscrire",
        "title": "Créer mon compte Securating"
    },
    "reviews": {
        "list": {
            "created_at": "Date de rédaction",
            "dialogs": {
                "cancel": {
                    "text": "Confirmez-vous l'annulation des modification en cours ?",
                    "title": "Annulation"
                },
                "remove": {
                    "text": "Confirmez-vous la suppression de votre avis ? Attention, il ne subsistera plus aucune trace de votre avis.",
                    "title": "Confirmation de l'effacement"
                },
                "validate": {
                    "text": "Confirmez-vous la modification du statut de modération ?",
                    "title": "Statut de modération"
                }
            },
            "empty": "Aucune publication n'a été trouvée pour votre compte.",
            "filters": {
                "created_at": "Date de publication",
                "group_default": "Tous mes groupes",
                "group_title": "Filtrage par groupe",
                "label": "Filtres",
                "moderate": "Modéré",
                "order": {
                    "asc": "Tri décroissant",
                    "desc": "Tri croissant"
                },
                "private": "Note personnelle",
                "rating": "Note",
                "search_title": "Filtrage par mots clés",
                "securating": "Exclure les avis SR"
            },
            "group": {
                "intro": {
                    "me": "Avis privé "
                }
            },
            "item": "Mon avis sélectionné",
            "loading": "Chargement...",
            "menu_name": "Mes avis",
            "moderate": "Statut de la modération",
            "moderated": "Modéré",
            "not-moderated": "Non modéré",
            "private": "Note personnelle",
            "product": {
                "intro": {
                    "manager": "Avis concernant le produit: ",
                    "me": "Votre Avis à propos du produit: "
                }
            },
            "rating": "Note de mon avis",
            "response": "Réponse du site",
            "review-link": "Voir mon avis sur le site",
            "thematic": {
                "intro": {
                    "manager": "Avis concernant: ",
                    "me": "Votre Avis à propos de: "
                }
            },
            "title": "Liste de mes avis",
            "update": {
                "buttons": {
                    "cancel": "Annuler mes modifications",
                    "delete": "Effacer mon avis",
                    "reply": "Répondre",
                    "unvalidate": "Invalider mon avis",
                    "update": "Modifier mon avis",
                    "validate": "Valider mon avis"
                },
                "edit": "Modifier mon avis",
                "group_public": "Avis publique",
                "message": "Message",
                "response": "Réponse",
                "review": "Avis",
                "title": "Titre"
            },
            "updated_at": "Date de la dernière mise à jour"
        },
        "validate": {
            "menu_name": "Validation des publications",
            "title": "Valider mes publications"
        }
    },
    "social": {
        "email": {
            "clear": "Effacer le contenu",
            "contacts": "Email",
            "error": "Vous avez déjà envoyé un email aux contacts suivants",
            "menu_name": "Par email",
            "message": "Message",
            "send": "Vos emails ont bien été envoyés",
            "subject": "Sujet de l'email",
            "submit": "Envoyer l'email",
            "template": {
                "message": "Hello, \n\nTu devrais regarder Securating.\n\nC'est vraiment super pour savoir, si on peut avoir confiance dans un site. Il y a des avis en ligne déposés par les visiteurs!\n",
                "subject": "Securating permet de consulter des avis 100% libres !"
            },
            "title": "Invitez vos amis par email"
        },
        "facebook": {
            "menu_name": "Facebook",
            "share": "Partager sur Facebook",
            "title": "Invitez vos amis sur Facebook"
        },
        "history": {
            "body": "Message",
            "date": "Envoi",
            "from": "Origine",
            "menu_name": "Historique de mes emails",
            "subject": "Sujet",
            "title": "Historique des emails envoyés",
            "to": "Destinataire"
        },
        "invite": {
            "email": "Quel est son email ?",
            "first_name": "Quel est le prénom de votre ami(e) ?",
            "menu_name": "Inviter un ou une amie à donner son avis",
            "message": "Avez-vous un message à ajouter pour votre ami(e) ?",
            "message_placeholder": "Par exemple un petit mot sur la raison de votre demande...",
            "thematic": "Quelle question souhaitez-vous poser à votre ami(e) ?",
            "title": "Demandez à vos amis leur avis sur un site en particulier",
            "website": "Pour quel site internet ?",
            "website_error": "Le site n'est pas joignable",
            "website_placeholder": "https://le-site-a-visiter.com"
        },
        "linkedin": {
            "menu_name": "Linkedin",
            "share": "Partager Securating sur Linkedin",
            "title": "Invitez vos amis sur linkedin"
        },
        "promote": {
            "menu_name": "Faire connaitre Securating",
            "title": "Merci de nous aider à faire connaitre Securating"
        },
        "title": "Invitations",
        "twitter": {
            "menu_name": "Twitter",
            "message": "Votre Tweet",
            "share": "Partager Securating sur Twitter",
            "title": "Invitez vos amis sur Twitter"
        },
        "warning": "Vous ne pouvez envoyer cet mail d'information qu'à vos amis, Securating ne conserve aucune informations sur vos envoies.",
        "whatsapp": {
            "menu_name": "WhatsApp",
            "message": "Message",
            "phone": "Numéro du contact",
            "share": "Partager Securating sur WhatsApp",
            "title": "Invitez vos amis sur WhatsApp"
        }
    },
    "stories": {
        "create": {
            "cancel": "Annuler",
            "menu_name": "Nouvelle story",
            "save": "Créer ma story",
            "title": "Racontez votre story"
        },
        "list": {
            "menu_name": "Stories"
        },
        "manager": {
            "dialogs": {
                "cancel": {
                    "text": "Confirmez-vous l'annulation des modification en cours ?",
                    "title": "Annulation"
                },
                "publish": {
                    "text": "Confirmez-vous le passage de cette story en public ?",
                    "title": "Statut de modération"
                },
                "remove": {
                    "text": "Confirmez-vous la suppression de la story ? Vous ne pourrez pas revenir en arrière.",
                    "title": "Confirmation"
                },
                "report": {
                    "text": "Souhaitez-vous signaler cette story ?\n Le niveau de confiance de diminuera drastiquement et ne sera pas affiché. <br>\nAttention ! Signaler une story pour de mauvaises raisons peut faire l'objet de sanctions.\n",
                    "title": "Signaler un avis"
                }
            },
            "editor": {
                "cancel": "Annuler les modifications",
                "html": "Contenu de la story",
                "image": "Image fournie par l'utilisateur",
                "render": "Rendu de la story",
                "save": "Sauvegarder les modifications",
                "template": "Template choisi par l'utilisateur"
            },
            "error": {
                "fetch_stories": "Impossible de charger la liste des stories",
                "fetch_websites": "Impossible de charger la liste des sites",
                "patch_story": "Erreur lors de la mise à jour de la story"
            },
            "list": {
                "confidence": "Pourcentage de confiance",
                "created_at": "Date de publication",
                "host": "Cliquez ici pour voir la story sur la page",
                "likes_counter": "Nombre de mentions j'aime",
                "moderation": "Status de modération",
                "nothing": "...",
                "published": "Publiée",
                "rejected": "Rejetée",
                "reload": "Rechargement",
                "search": "Recherche dans les avis",
                "title": "Liste des Stories",
                "waiting": "En attente",
                "websites": "Choisissez un site à modérer"
            },
            "render": {
                "edit": "Modifier la Story",
                "publish": "Publier la Story",
                "published": "Story publiée et visible par vos visiteurs",
                "reason": "Motif du rejet",
                "rejected": "Story rejetée et invisible de vos visiteurs"
            },
            "response": {
                "buttons": {
                    "back": "Précédent",
                    "cancel": "Annuler les modifications",
                    "delete": "Supprimer la réponse",
                    "edit": "Editer la réponse",
                    "publish": "Publier la story",
                    "reply": "Répondre",
                    "report": "Rejeter la story",
                    "start": "Retour",
                    "update": "Suivant"
                },
                "message": "Donnez une réponse (optionnel)",
                "pertinence": "Pertinence de la story",
                "publish": "Publier la story pour le rendre visible",
                "report": {
                    "1": "Grossier ou vulgaire",
                    "2": "Discrimination, incitation à la haine",
                    "3": "Humiliation publique",
                    "4": "Spam",
                    "5": "Contenu commercial ou auto-promotion",
                    "6": "Message relevant de la communication privée",
                    "7": "Problème de sécurité, de fraude ou de légalité",
                    "8": "Menace l’intégrité physique d’une personne",
                    "9": "Violation de la vie privée d'une personne",
                    "label": "Motif du rejet",
                    "title": "Signaler la story"
                },
                "title": "Publication de la story",
                "update_date": "{date}"
            }
        },
        "me": {
            "dialogs": {
                "remove": {
                    "text": "Confirmez-vous la suppression de la story ? Vous ne pourrez pas revenir en arrière.",
                    "title": "Confirmation"
                }
            },
            "editor": {
                "cancel": "Fermer et annuler mes modifications",
                "html": "Message de votre Story",
                "image": "Image de votre Story",
                "render": "Apparence de votre Story",
                "save": "Enregistrer mes modifications",
                "template": "Organisation de votre Story",
                "url": "Votre Story est visible sur le site"
            },
            "empty": {
                "content": "Cet espace est dédié aux partages d'expériences positives.<br>Racontez-nous ici votre petite histoire en lien avec ce site.<br>",
                "image_url": "https://cdn.securating.io/static/image/799d1aa84b35aa7470a8f115332af340e805386cae507e670844b7d26f2d9609",
                "title": "Racontez votre Histoire"
            },
            "error": {
                "fetch_stories": "Impossible de charger la liste des stories",
                "patch_story": "Erreur lors de la mise à jour de la story",
                "post_story": "Erreur lors de la création de la story"
            },
            "list": {
                "created_at": "Date de publication",
                "host": "Cliquez ici pour voir votre Story sur la page",
                "likes_counter": "Nombre de mentions j'aime",
                "moderation": "Status de modération",
                "nothing": "...",
                "published": "Publiée",
                "rejected": "Rejetée",
                "title": "Liste de mes Stories",
                "waiting": "En attente"
            },
            "render": {
                "edit": "Changer ma Story",
                "published": "Cette Story a été publiée et elle est visible sur le site",
                "reason": "Motif du rejet",
                "rejected": "Cette Story a été rejetée et elle n'est pas visible sur le site"
            },
            "response": {
                "buttons": {
                    "back": "Précédent",
                    "cancel": "Annuler les modifications",
                    "delete": "Supprimer la réponse",
                    "edit": "Editer la réponse",
                    "publish": "Publier la story",
                    "reply": "Répondre",
                    "report": "Rejeter la story",
                    "start": "Retour",
                    "update": "Suivant"
                },
                "message": "Donnez une réponse (optionnel)",
                "pertinence": "Pertinence de la story",
                "publish": "Publier la story pour le rendre visible",
                "report": {
                    "1": "Grossier ou vulgaire",
                    "2": "Discrimination, incitation à la haine",
                    "3": "Humiliation publique",
                    "4": "Spam",
                    "5": "Contenu commercial ou auto-promotion",
                    "6": "Message relevant de la communication privée",
                    "7": "Problème de sécurité, de fraude ou de légalité",
                    "8": "Menace l’intégrité physique d’une personne",
                    "9": "Violation de la vie privée d'une personne",
                    "label": "Motif du rejet",
                    "title": "Signaler la story"
                },
                "title": "Publication de la story",
                "update_date": "{date}"
            }
        }
    },
    "suggestions": {
        "params": {
            "bt": {
                "clear": "Effacer le contenu",
                "send": "Sauvegarder ces paramètres"
            },
            "form": {
                "exclude": "Noms de domaine ou mots à exclure",
                "excludePlaceHolder": "indiquez ici les mots interdits (un par ligne)",
                "exclude_domains": "Exclure un site proposé par le robot de suggestion de Securating",
                "exclude_word": "Ajouter un mot clé à exclure",
                "exclude_word_add": "Exclure le mot clé",
                "exclude_word_placeholder": "Tapez votre mot clé ici, puis appuyez sur la touche entrée",
                "wanted_label": "Les suggestions sont visibles sur votre site ",
                "wanted_title": "Affichage des suggestions",
                "website_not_selected": "Sélectionnez un site pour continuer",
                "website_title": "Site pour lequel vous souhaitez paramètrer les suggestions"
            },
            "menu_name": "Paramétrages",
            "messages": {
                "sendDone": "Paramétrage mis à jour.",
                "sendError": "Une erreur c'est produite, merci de reformuler votre demande."
            },
            "title": "Paramétrage des suggestions de votre site",
            "website": "Site à paramètrer"
        },
        "url": {
            "menu_name": "Vos pages",
            "title": "Gestion de vos pages"
        }
    },
    "thematics": {
        "dialogs": {
            "main": {
                "newcode": "Renseignez ici uniquement les 3 derniers chiffres de l'identifiant désiré",
                "title": "Sujet de sondage "
            }
        },
        "form": {
            "delete": "Voulez-vous réellement supprimer ce sujet ?",
            "new": "Ajouter un nouveau sujet",
            "title": "Selection des sondages",
            "title_generic": ", sondages prédéfinis par langue : "
        },
        "refresh": "Chargement",
        "scope": {
            "private": "Oui",
            "public": "Non"
        },
        "table": {
            "actions": "Actions",
            "description": "Aide à la collecte de l'avis",
            "id": "Code",
            "scope": "Cible",
            "thematic": "Sujet du sondage"
        }
    },
    "urls": {
        "dialogue": {
            "statistics": {
                "datatable": {
                    "affichage": "Nombre d'affichages sur des sites distants",
                    "date": "Date d'affichage"
                },
                "title": "Nombre d'affichages de cette page dans les suggestions présentées sur d'autres sites Internet"
            }
        },
        "url": {
            "cancel_description": "Annuler",
            "cancel_keywords": "Annuler",
            "cancel_title": "Annuler",
            "cancel_url": "Annuler",
            "datatable": {
                "actions": "Actions",
                "description": "Description",
                "keywords": "Mots-clés",
                "label": "Liste des pages",
                "no_keywords": "Aucun",
                "suggestions_updated_at": "Mise à jour des suggestions",
                "title": "Titre",
                "url": "URL"
            },
            "delete_url": "Supprimer l'URL",
            "description_action": "Modifier la description",
            "edit_description": "Saisissez une description",
            "edit_keywords": "Sélectionnez jusqu'à quatre mots-clés.",
            "edit_title": "Saisissez un titre",
            "edit_url": "Saisissez une URL",
            "errors": {
                "0acff2d0-32f7-11eb-a735-2f611aedb318": "La longueur du titre ne peut dépasser 70 caractères.",
                "1038bc74-364f-11eb-8444-d3865411da55": "La mise à jour des mots-clés a échouée",
                "19168722-3573-11eb-be6d-7f7c9e8bc010": "La création de la nouvelle URL a échouée dû à une erreur interne.",
                "23ad9d02-32f7-11eb-88da-6bcceec010f0": "La longueur de la description ne peut dépasser 160 caractères.",
                "3bebb86c-32f8-11eb-a3e4-8f2040bd40e2": "Impossible d'ajouter plus de quatre mots-clés par URL.",
                "51b60d90-32f4-11eb-8f47-43249515f200": "L'URL saisie est malformée",
                "7e8c6e5c-364d-11eb-a515-8f30001227e5": "La mise à jour du titre a échouée.",
                "8439658a-364d-11eb-8ec6-5fb06059d5ed": "La mise à jour de la description a échouée",
                "9565ae58-32f7-11eb-a5df-a784fb9d328e": "La longueur de l'URL ne peut dépasser 2056 caractères.",
                "aa0ea050-3647-11eb-9f84-ff3891b3cea7": "La création de la nouvelle URL a échouée dû à une erreur interne.",
                "alert": "Veuillez corriger l'erreur suivante|Veuillez corriger les erreurs suivantes",
                "b461b9ca-357f-11eb-91cf-178b8457856f": "L'URL existe déjà, elle doit être visible dans la liste.",
                "c04d220e-364e-11eb-816e-2f9733cf06f2": "La mise à jour des mots-clés a échouée",
                "c6cd8470-3581-11eb-a1fb-1fc03576ef28": "Impossible de créer l'URL dû à une erreur interne, merci de réessayer ultérieurement.",
                "cc2c6b56-3569-11eb-9e40-6733a07f9012": "Impossible d'ajouter une nouvelle URL pour ce site",
                "description_counter": "La longueur de la description ne peut dépasser 160 caractères.",
                "e1fa18ba-364b-11eb-95ab-3f2f1b5d5b92": "Impossible de vérouiller l'URL.",
                "e24e4ac0-364b-11eb-a759-cb97a9ea6fb2": "Mise à jour impossible dû à une erreur interne.",
                "e2965b26-364b-11eb-be3b-2358e8d68a62": "Mise à jour impossible dû à une erreur interne.",
                "f9b3c4a2-363b-11eb-a4f5-9b1b8814efdf": "La création de la nouvelle URL a échouée dû à une erreur interne.",
                "fde3c72e-364b-11eb-a311-6f6ae0e47a2f": "Impossible de dévérouiller l'URL.",
                "keywords_counter": "Impossible d'ajouter plus de quatre mots-clés par URL.",
                "no_selected_website": "Sélectionnez d'abord un site à référencer.",
                "title_counter": "La longueur du titre ne peut dépasser 70 caractères."
            },
            "has_not_right_plan": "Vous n'avez pas le bon abonnement pour changer les mots-clés de ce site. Passez à la formule SMART ou supérieure.",
            "keyword_action": "Modifier les mots clés",
            "lock": "Vérouiller la modification de l'URL par Securating",
            "menu_name": "Gérer mon référencement",
            "new_url": "Ajouter une nouvelle URL",
            "save_description": "Enregistrer la description",
            "save_keywords": "Enregistrer les mots-clés",
            "save_title": "Enregistrer le titre",
            "save_url": "Enregistrer la nouvelle URL",
            "search": "Rechercher",
            "search_label": "Filter la liste",
            "stats": "Statistiques",
            "stats_suggestions": "{counter} affichages des suggestions sur ce site.",
            "success": {
                "delete_url": "L'URL a été supprimée.",
                "description_save": "La description a été enregistrée.",
                "keywords_save": "Les mots-clés ont été enregistrés.",
                "locked": "L'URL a été verrouillée.",
                "title_save": "Le titre a été enregistré.",
                "unlocked": "L'URL a été déverrouillée."
            },
            "suggestions": "Ouvrir les suggestions sur le site",
            "title": "Gérer vos URL",
            "title_action": "Modifier le titre",
            "unlock": "Dévérouiller la modification de l'URL par Securating",
            "update_description": "Mettre à jour la description",
            "update_keywords": "Mettre à jour des mots-clés",
            "update_title": "Mettre à jour le titre",
            "url_action": "Ouvrir cette page",
            "website": "Site à référencer",
            "website_not_selected": "Sélectionnez un site pour continuer"
        }
    },
    "wall": {
        "manager": {
            "editor": {
                "activity": "Dites-nous en plus sur votre activité",
                "claim": "Réclamez votre nom de domaine maintenant",
                "claim_domain": "Récupérer ce nom de domaine",
                "claimed": "Décrivez-nous votre activité",
                "confirm": {
                    "delete": "Êtes-vous sur de vouloirs supprimés votre page définitivement ? Il vous sera impossible de revenir en arrière ensuite..."
                },
                "delete_wall": "Supprimer ma page",
                "domain": "Votre nom de domaine",
                "domain_prefix": "https://securating.pro/",
                "domain_suffix": "/",
                "errors": {
                    "delete": "Erreur lors de la suppression de la page personnelle.",
                    "update": "Erreur lors de la  mise à jour de la page personnelle."
                },
                "form": {
                    "address": "Adresse de votre entreprise",
                    "category": "Secteur d'activité",
                    "description": "Contenu de la page",
                    "images": "Images",
                    "meta_description": "Meta description",
                    "meta_tags": "Mots-clés",
                    "meta_title": "Meta titre",
                    "title": "Titre de la page"
                },
                "meta": "Meta informations de votre page pour le référencement (SEO)",
                "success": {
                    "delete": "Page personnelle supprimée.",
                    "update": "Page personnelle mise à jour."
                },
                "title": "Ma page personnelle",
                "update_wall": "Mettre à jour ma page"
            }
        }
    },
    "websites": {
        "authorized": "Modifications des informations relative à votre site",
        "copied": "copié",
        "delete": "Supprimer ce site",
        "delete_image": "Supprimer",
        "dialogs": {
            "actions": {
                "btn_change_key": "Changer la clé d'activation de ce site",
                "btn_count": "Re-calculer la note de ce site",
                "btn_delete": "Supprimer ce site",
                "btn_verify": "Vérifier la clé de ce site",
                "label_actions": "Mise à jour possibles",
                "label_actions_criticals": "Opérations critiques de ce site",
                "title": "Autres actions sur votre site",
                "attestation": "Attestation"
            },
            "edit": {
                "tabs" : {
                    "notification" : {
                        "title" : "Alertes"
                    },
                    "contact" : {
                        "title" : "Contact"
                    },
                    "share" : {
                        "title" : "Partages"
                    },
                    "display" : {
                        "title" : "Affichage"
                    }
                },
                "label_contact_title": "Ces informations sont affichées sur l'attestation de votre de site",
                "label_contact_logo": "Logo de votre site",
                "label_contact_email": "Email",
                "label_contact_phone": "Téléphone",
                "label_contact_headline": "Slogan de votre site",
                "label_contact_public_name": "Nom public de votre site",
                "label_contact_street": "Adresse postale",
                "label_contact_further_information": "Complément d'adresse",
                "label_contact_zip": "Code postal",
                "label_contact_city": "Ville",
                "label_contact_country": "Pays",

                "label_authorized": "Sites internet autorisés à afficher les avis services de ce site",
                "label_menu": "Affichage du Menu de l'extension Securating",
                "label_notification_email": "Email de notification",
                "label_notification_name": "Nom du contact",
                "menu_no": "Non, l'extension n'est pas encore proposée à vos visiteurs",
                "menu_yes": "Oui, l'extension est proposée à vos visiteurs",
                "title": "Paramètrage de votre site"
            },
            "remove": {
                "text": "Confirmez-vous la suppression du site ?",
                "title": "Suppression du site"
            },
            "reset": {
                "text": "Confirmez-vous le changement de la clé d'activation?",
                "title": "Changer la clé d'activation"
            },
            "tokens": {
                "available": "Abonnements disponibles",
                "color_0": "#b8b8b8",
                "color_1": "#ff6b00",
                "color_2": "#28a745",
                "color_3": "#007bff",
                "color_4": "#ffc107",
                "nothing_available": "Aucun jeton d'abonnement disponible",
                "nothing_used": "Aucun jeton d'abonnement utilisé",
                "plan_0": "Gratuit",
                "plan_1": "Start",
                "plan_2": "Smart",
                "plan_3": "Max",
                "plan_4": "No-Limit",
                "plan_99": "plan-99",
                "text": "Quel abonnement souhaitez-vous utiliser sur ce site ?",
                "source": "Vos jetons sont créés avec votre abonnement [MON COMPTE / ABONNEMENTS].",
                "title": "Attribution des jetons d'abonnements"
            }
        },
        "download": {
            "title": "Téléchargement des avis de ce site",
            "requested": "Votre fichier est en préparation"
        },
        "editor": {
            "menu_name": "Page personnelle"
        },
        "form": {
            "host": "Ajouter",
            "title": "Nouveau site",
            "add_host": "Ajouter votre nouveau site ici..."
        },
        "not_copied": " non copié dans le presse-papier",
        "plan": {
            "change": "Changer l'abonnement"
        },
        "rate": "Calculer la note de ce site",
        "refresh": "Rafraîchir la liste des sites",
        "reset": "Changer la clé d'activation",
        "reviews_params": {
            "bt": {
                "send": "Sauvegarder ces paramètres"
            },
            "form": {
                "exclude_title": "Sélection des avis",
                "age_selection": "Ancienneté des avis",
                "max_age": "Les avis ne répondant pas à ce critère ne seront pas pris en compte (note + widget)",
                "exclude_free_label": "Masquer les avis non sollicités (libres)",
                "exclude_thematic_label": "Masquer tous les avis liés aux sondages",
                "filter_thematic_label": "A l'exception de (1000100,1000200,etc)",
                "exclude_product_label": "Masquer tous les avis liés aux produits",
                "filter_product_label": "A l'exception de (0001, 0001-*,etc)",
                "order_best_label": "Les avis les mieux notés sont affichés en premier",
                "order_last_label": "Les avis les plus récents sont affichés en premier",
                "order_liked_label": "Les avis les plus aimés sont affichés en premier",
                "order_pertinent_label": "Les avis les plus pertinent sont affichés en premier",
                "order_title": "Ordre d'affichage initial des avis publiés",
                "website_title": "Site pour lequel vous souhaitez paramètrer l'affichage des avis",
                "legal_link_title": "Règles de publication et de modération",
                "legal_link_placeholder": "Url sur votre site internet",
                "ext_review_url_title": "Lien d'invitation de dépose d'avis externe",
                "ext_review_url_placeholder": "Url du lien d'invitation"
            },
            "menu_name": "Paramétrages",
            "messages": {
                "sendDone": "Paramétrage mis à jour.",
                "sendError": "Une erreur c'est produite, merci de reformuler votre demande."
            },
            "title": "Paramétrage de l'affichage des avis sur vos sites",
            "website": "Site à paramètrer"
        },
        "sites": {
            "menu_name": "Mes sites",
            "title": "Activez vos sites Internet"
        },
        "table": {
            "actions": "Actions",
            "hash": "Activations",
            "host": "Sites",
            "plan": "Abonnements",
            "status": "Actions",
            "title": "Vos sites"
        },
        "title": "Gestion de vos sites",
        "title_key": "Cliquez ici pour télécharger la clé d'activation",
        "verification": {
            "level0": "La clé d'activation de votre site n'a pas pu être vérifiée.",
            "level1": "La clé d'activation a bien été vérfiée, installez le plugin pour finaliser votre installation.",
            "level2": "Votre site a bien été vérfié."
        },
        "verified_l0": "Votre site internet n'a pas été vérifié. Installez la clé d'activation puis demandez la vérification de votre site.",
        "verified_l1": "Votre site internet a bien été vérifié.",
        "verify": "Vérifier ce site"
    }
}


//-- To translate the Json :
//-- 1/ Reformat the Json {...} usin online serivces https://jsonformatter.curiousconcept.com/#
//-- 2/ Save the content {...] in a fr.json, en.json, es.json, de.json, etc... file on windows
//-- 3/ Open the files on babel